import { z } from "zod";
import { DbBool, IsoDateTime, LocalIdSchema, PositionSchema } from "./common.ts";

export const FolderSchema = z.object({
  id: LocalIdSchema,
  name: z.string().min(1).max(200),
  /** Nestable, unlike v0's flat list. Read the tree with a recursive CTE. */
  parent_id: LocalIdSchema.nullable(),
  position: PositionSchema,
  collapsed: DbBool,
  created_at: IsoDateTime,
});

export type Folder = z.infer<typeof FolderSchema>;

export const FolderCreateSchema = z.object({
  name: z.string().trim().min(1).max(200),
  parent_id: LocalIdSchema.nullable().optional(),
  /** Omit to append. Provide neighbours to drop between two siblings. */
  after_id: LocalIdSchema.nullable().optional(),
  before_id: LocalIdSchema.nullable().optional(),
});

export type FolderCreate = z.infer<typeof FolderCreateSchema>;

export const FolderUpdateSchema = z
  .object({
    name: z.string().trim().min(1).max(200),
    parent_id: LocalIdSchema.nullable(),
    collapsed: z.boolean(),
    after_id: LocalIdSchema.nullable(),
    before_id: LocalIdSchema.nullable(),
  })
  .partial();

export type FolderUpdate = z.infer<typeof FolderUpdateSchema>;

/** A folder plus its children, as returned by the sidebar tree endpoint. */
export interface FolderNode extends Folder {
  children: FolderNode[];
}

export const FolderNodeSchema: z.ZodType<FolderNode> = FolderSchema.extend({
  children: z.lazy(() => z.array(FolderNodeSchema)),
});
